export const ALL_SA_BANDS = {
  LIFE_COVER: {
    ALL: {
      1: 5000000,
      2: 7500000,
      3: 10000000,
      4: 15000000,
      5: 20000000,
      6: 30000000,
      7: 50000000,
      // 8: 3500000,
      // 9: 4000000,
      // 10: 4500000,
      // 11: 5000000,
      // 12: 6000000,
      // 13: 7000000,
      // 14: 8000000,
      // 15: 9000000,
      // 16: 10000000,
      // 17: 12000000,
      // 18: 15000000,
      // 19: 20000000,
      // 20: 30000000,
      // 21: 50000000,
    },
    SP: {
      1: 5000000,
      2: 10000000,
      3: 30000000,
    },
  },
  CI: {
    1: 100000,
    2: 200000,
    3: 300000,
    4: 400000,
    5: 500000,
    6: 1000000,
    7: 2500000,
    8: 10000000,
    9: 20000000,
  },
};
